import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import Img from "../Assets/icons/VELOXLogo.png";
import "../Styles/login.css";
import "../Styles/UserManagement.css";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';
import CloudProHeader from './CloudProHeader';
 import logo from '../Assets/icons/velox_logo.png'
import { IoEyeOff } from "react-icons/io5";
import { IoEye  } from "react-icons/io5";
const CloudProUpdatePassword = () => {
  const [openYubikeyDialog, setOpenYubikeyDialog] = useState(false);
  const [yubikeyCode, setYubikeyCode] = useState('');
  const yubikeyInputRef = useRef(null);
  const dialogContentRef = useRef(null);
  const [passwordToChange, setPasswordToChange] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const formikRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handlePasswordChange = (values) => {
    if (values.password !== values.confirmPassword) {
      toast.error("Passwords do not match", {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }
    setPasswordToChange(values.password);
    setOpenYubikeyDialog(true);  // Open YubiKey verification dialog
  };

  const handleYubikeyVerification = () => {
    const email = localStorage.getItem('userEmail');
    Axios.post(`/change_customer_password`, {
      email: email,
      password: passwordToChange,
      yubikeyContent: yubikeyCode,
    }).then((response) => {
      if (response.data.success) {
        toast.success("Password changed successfully");
        setYubikeyCode('');
        setOpenYubikeyDialog(false);
        setPasswordToChange('');
        formikRef.current?.resetForm();
      } else {
        toast.error(response.data.msg);
        if (yubikeyInputRef.current) {
            yubikeyInputRef.current.focus();
          }
      }
      setYubikeyCode('');
    }).catch((error) => {
      toast.error("YubiKey verification failed");
      setYubikeyCode('');
      if (yubikeyInputRef.current) {
        yubikeyInputRef.current.focus();
      }
    });
  };

  const handleBack = () => {
    console.log("Back button clicked!");         
    console.log("Current path:", location.pathname);
    // Dismiss any active toasts before navigating
    toast.dismiss();
    // Check if we can go back in history
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);  // Go back one step in history
      console.log("Navigating back one step.");
    } else {
      // If no history, navigate to the dashboard without adding an entry
      navigate('/dashboard', { replace: true });
      console.log("No history to go back, redirecting to dashboard.");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('@user');
    localStorage.removeItem('userEmail');
    navigate('/', { replace: true });
  };

  useEffect(() => {
    const handleDialogClick = (event) => {
      if (dialogContentRef.current && yubikeyInputRef.current && !yubikeyInputRef.current.contains(event.target)) {
        yubikeyInputRef.current.focus();  // Refocus the input field when clicking outside of it
      }
    };

    if (openYubikeyDialog) {
      // Set focus when the dialog opens
      if (yubikeyInputRef.current) {
        yubikeyInputRef.current.focus();
      }

      // Add click event listener to the dialog content
      document.addEventListener('click', handleDialogClick);
    }

    // Cleanup event listener when the dialog is closed
    return () => {
      document.removeEventListener('click', handleDialogClick);
    };
  }, [openYubikeyDialog]);

  const validationSchema = yup.object().shape({
    password: yup
      .string()
      .min(8, "Password must be at least 8 characters")
      .matches(/[a-z]/, 'Password requires a lowercase letter')
      .matches(/[A-Z]/, 'Password requires an uppercase letter')
      .matches(/[0-9]/, 'Password requires a number')
      .matches(/[^\w]/, 'Password requires a symbol')
      .required("Password is mandatory"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref('password'), null], 'Passwords must match')
      .required('Confirm Password is mandatory'),
  });

  return (
    <div className="dashboard">
      {/* Logo and Navigation */}
      <CloudProHeader isAdmin={true} />
     <div className="main-container">
      <div className="login-card">

      
        <div className="logo-box">
          <img src={logo} alt="logo" />
        </div>

        <h2 className="title">Change Password</h2>
        <p className="subtitle">Please enter your new password</p>

        <Formik
          innerRef={formikRef}
          initialValues={{ password: "", confirmPassword: "" }}
          onSubmit={handlePasswordChange}
          validationSchema={validationSchema}
        >
          {({ values, setFieldValue }) => (
            <Form>

              {/* New Password */}
              <div className="input-group">
                <label>New Password</label>
                <div className="password-box">
                  <Field
                    name="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter new password"
                  
                  />
                  <span
                    className="eye"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <IoEyeOff /> : <IoEye />}
                  </span>
                </div>
                <ErrorMessage
                  name="password"
                  component="span"
                  className="form-error"
                />
              </div>

              {/* Confirm Password */}
              <div className="input-group">
                <label>Confirm Password</label>
                <div className="password-box">
                  <Field
                    name="confirmPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm new password"
                    
                  />
                  <span
                    className="eye"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? <IoEyeOff /> : <IoEye />}
                  </span>
                </div>
                <ErrorMessage
                  name="confirmPassword"
                  component="span"
                  className="form-error"
                />
              </div>

              {/* Error message */}
              {/* <p className="login-error">{submitError || ""}</p> */}

              <button className="signin-btn" type="submit">
                Verify Your YubiKey
              </button>

            </Form>
          )}
        </Formik>
      </div>
      </div>






      {/* YubiKey Verification Dialog */}
      <Dialog open={openYubikeyDialog} onClose={() => setOpenYubikeyDialog(false)}>
        <DialogTitle>YubiKey Verification</DialogTitle>
        <DialogContent ref={dialogContentRef}>
          <p>Please insert your YubiKey, touch it, and then verify.</p>
          <input
            type="text"
            ref={yubikeyInputRef}
            className="yubikeycode-field-hidden"
            placeholder="Enter YubiKey Code"
            value={yubikeyCode}
            onChange={(e) => setYubikeyCode(e.target.value)}
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenYubikeyDialog(false)} color="secondary">Cancel</Button>
          <Button onClick={handleYubikeyVerification} color="primary" disabled={!(yubikeyCode && yubikeyCode.length >= 12)}>
            Verify
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer />
    </div>
  );
};

export default CloudProUpdatePassword;
